import React, { useContext } from "react";

import Template from "../../components/template";
import TableView from "./components/TableView";
import PaginationView from "./components/PaginationView";
import HeaderView from "./components/HeaderView";
import CardWithHeaderTemplate from "../../components/cardWithHeaderTemplate";
const Html = () => {
    return(
        <Template
            children={
                <div className="container-fluid py-4">
                    <div className="row">
                        <div className="col-12">
                            <CardWithHeaderTemplate
                                header={<HeaderView />}
                                body={<TableView />}
                                footer={<PaginationView/>}
                            />
                        </div>
                    </div>
                </div>
            }
        />
    );
}
export default Html;